var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12073_117158",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H23V23H1V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12073_117158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.61978C10.1332 8.61978 8.6198 10.1331 8.6198 12C8.6198 13.8668 10.1332 15.3802 12 15.3802C13.8668 15.3802 15.3802 13.8668 15.3802 12C15.3802 10.1331 13.8668 8.61978 12 8.61978ZM21.4876 9.58786L20.5724 10.3413C19.5284 11.2007 19.5284 12.7993 20.5724 13.6587L21.4876 14.4121C21.8119 14.6791 21.8957 15.1414 21.6856 15.5053L19.8785 18.6353C19.6684 18.9991 19.2262 19.1578 18.8328 19.0104L17.7227 18.5945C16.4564 18.1202 15.072 18.9194 14.8497 20.2532L14.6548 21.4225C14.5858 21.8369 14.2273 22.1406 13.8072 22.1406H10.1928C9.77278 22.1406 9.41425 21.8369 9.3452 21.4225L9.15029 20.2532C8.92801 18.9194 7.5436 18.1202 6.27736 18.5945L5.1673 19.0104C4.77388 19.1578 4.3316 18.9991 4.12153 18.6353L2.31439 15.5053C2.10436 15.1414 2.18811 14.6791 2.51244 14.4121L3.42767 13.6587C4.4716 12.7993 4.4716 11.2007 3.42767 10.3413L2.51244 9.58786C2.18811 9.32086 2.10436 8.85851 2.31439 8.4947L4.12153 5.36464C4.3316 5.00082 4.77388 4.84218 5.1673 4.98956L6.27736 5.40542C7.5436 5.87979 8.92801 5.08053 9.15029 3.74674L9.3452 2.57743C9.41425 2.16308 9.77278 1.85938 10.1928 1.85938H13.8072C14.2273 1.85938 14.5858 2.16308 14.6548 2.57743L14.8497 3.74674C15.072 5.08053 16.4564 5.87979 17.7227 5.40542L18.8328 4.98956C19.2262 4.84218 19.6684 5.00082 19.8785 5.36464L21.6856 8.4947C21.8957 8.85851 21.8119 9.32086 21.4876 9.58786Z",
    stroke: "#6F767E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.1a1393765d150e2b02178514f9e44e99.svg";
export { ForwardRef as ReactComponent };